import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../constants';

@Injectable()
export class FindOrderService {

  private apiUrl = globalConst.baseAPI;  // URL para web api
  
    /**
    * Método construtor
    * @param http: Http
    */
    constructor(private http: Http) { }

    getOrderByID(idOrder){
      console.log(this.apiUrl + "order/v1/getbyid/" + idOrder);
      return this.http
      .get(this.apiUrl + "order/v1/getbyid/" + idOrder, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
 }
  

}


// WEBPACK FOOTER //
// ./src/app/find-order/service/find-order.service.ts